/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */
import {faker} from '@faker-js/faker';

import type {RequestHandlerOptions} from 'msw';
import {HttpResponse, http} from 'msw';

import type {UserListResponse, UserResponse} from '../../models';
import {InstanceUserRoleID} from '../../models';

export const getGetUsersResponseMock = (
  overrideResponse: Partial<Extract<UserListResponse, object>> = {},
): UserListResponse => ({
  total_pages: faker.number.int(),
  users: Array.from({length: faker.number.int({min: 1, max: 10})}, (_, i) => i + 1).map(() => ({
    display_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
    email: faker.internet.email(),
    eula_accepted_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]),
    id: faker.string.uuid(),
    instance_user_role_id: faker.helpers.arrayElement(Object.values(InstanceUserRoleID)),
    organization: {
      data_enclave_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
      email_domains: faker.helpers.arrayElement([
        Array.from({length: faker.number.int({min: 1, max: 10})}, (_, i) => i + 1).map(() =>
          faker.string.alpha({length: {min: 10, max: 20}}),
        ),
        Array.from({length: faker.number.int({min: 1, max: 10})}, (_, i) => i + 1).map(() => ({
          domain_name: faker.string.alpha({length: {min: 10, max: 20}}),
        })),
      ]),
      entity_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
      full_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
      id: faker.string.uuid(),
      name: faker.helpers.fromRegExp('^[A-Za-z0-9]+(?:[-_][A-Za-z0-9]+)*$'),
    },
  })),
  ...overrideResponse,
});

export const getGetUserResponseMock = (
  overrideResponse: Partial<Extract<UserResponse, object>> = {},
): UserResponse => ({
  display_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
  email: faker.internet.email(),
  eula_accepted_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]),
  id: faker.string.uuid(),
  instance_user_role_id: faker.helpers.arrayElement(Object.values(InstanceUserRoleID)),
  organization: {
    data_enclave_url: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
    email_domains: faker.helpers.arrayElement([
      Array.from({length: faker.number.int({min: 1, max: 10})}, (_, i) => i + 1).map(() =>
        faker.string.alpha({length: {min: 10, max: 20}}),
      ),
      Array.from({length: faker.number.int({min: 1, max: 10})}, (_, i) => i + 1).map(() => ({
        domain_name: faker.string.alpha({length: {min: 10, max: 20}}),
      })),
    ]),
    entity_id: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
    full_name: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]),
    id: faker.string.uuid(),
    name: faker.helpers.fromRegExp('^[A-Za-z0-9]+(?:[-_][A-Za-z0-9]+)*$'),
  },
  ...overrideResponse,
});

export const getGetUsersMockHandler = (
  overrideResponse?:
    | UserListResponse
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<UserListResponse> | UserListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/api/users',
    async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
      return HttpResponse.json(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetUsersResponseMock(),
        {status: 200},
      );
    },
    options,
  );
};

export const getCreateUserMockHandler = (
  overrideResponse?:
    | unknown
    | void
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<unknown | void> | unknown | void),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/api/users',
    async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }

      return new HttpResponse(null, {status: 200});
    },
    options,
  );
};

export const getGetUserMockHandler = (
  overrideResponse?:
    UserResponse | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<UserResponse> | UserResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/api/users/:userId',
    async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
      return HttpResponse.json(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetUserResponseMock(),
        {status: 200},
      );
    },
    options,
  );
};

export const getPatchUserMockHandler = (
  overrideResponse?:
    | unknown
    | void
    | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<unknown | void> | unknown | void),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/api/users/:userId',
    async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }

      return new HttpResponse(null, {status: 200});
    },
    options,
  );
};

export const getUpdateUserMockHandler = (
  overrideResponse?:
    | unknown
    | void
    | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<unknown | void> | unknown | void),
  options?: RequestHandlerOptions,
) => {
  return http.put(
    '*/api/users/:userId',
    async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }

      return new HttpResponse(null, {status: 200});
    },
    options,
  );
};
export const getUserMock = () => [
  getGetUsersMockHandler(),
  getCreateUserMockHandler(),
  getGetUserMockHandler(),
  getPatchUserMockHandler(),
  getUpdateUserMockHandler(),
];
